import { CSSProperties } from 'react';

type ColorVariants = 'textPrimary' | 'textSecondary' | 'inherit';

type SizeVariation = 'extraSmall' | 'small' | 'medium' | 'large';

export enum MoneyRendererV3DirectionEnum {
  ROW = 'row',
  COLUMN = 'column',
}

export interface MoneyRendererV3Props {
  value: number;
  color?: ColorVariants;
  promotionTextColor?: ColorVariants;
  promotionValue?: number;
  direction?: MoneyRendererV3DirectionEnum;
  horizontalAlign?: 'left' | 'right';
  size?: SizeVariation;
  useSign?: boolean;
  originalPriceTestId?: string;
  discountedPriceTestId?: string;
  valueTestId?: string;
  integerValueTestId?: string;
  centsValueTestId?: string;
}

export interface MoneyRendererV3StylesProps {
  size: SizeVariation;
  promotionTextColor?: ColorVariants;
}

export interface SizeStyles {
  cents: CSSProperties;
  principal: CSSProperties;
  promotion: CSSProperties;
}
export type UseMoneyRendererV3Props = Pick<
  MoneyRendererV3Props,
  'promotionValue' | 'value' | 'useSign'
>;

export type MoneySizeStyles = Record<SizeVariation, SizeStyles>;
